import React, { useEffect } from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import AboutCard from '../AboutCard';
import Training from './Training';
import Card from './Card';
import Badges from './Badges';
import Stats from '../Stats';


function Home() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);
  
  return (
    
    <>
      <HeroSection />
      <AboutCard/>
      <br></br>
      <Badges />
      <Cards />
      {/* <Card/> */}
      <Stats/>
      <Training/>
    </>
  );
}

export default Home;
